/**
 * In-memory access token. Never persisted to localStorage/sessionStorage —
 * durability comes from the httpOnly `refreshToken` cookie set by the API;
 * the access token is rebuilt on every page load via POST /auth/refresh.
 *
 * Exists as a module-scoped singleton so the apiFetch wrapper can read the
 * current token without touching React. AuthContext owns the lifecycle and
 * is the only legitimate writer.
 */
let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}
